import React from "react";
import LoadingGIF from "../../assets/blue_loading.gif";
import * as S from "./styles";

const FileUploadSpinner: React.FC = () => (
  <S.Container>
    <S.ImageContainer>
      <div className="flex-row">
        <img src={LoadingGIF} alt="로딩중" />
        <p>파일 업로드 중...</p>
      </div>
    </S.ImageContainer>
  </S.Container>
);

export default FileUploadSpinner;
